export default "__VITE_ASSET__B$piQOKq__"